import React from 'react'
import ManageProspectForm from '../../../../modules/ManageProspect/Form'

const Index = () => {
  return <ManageProspectForm caseType="view" />
}
export default Index
